import { render, staticRenderFns } from "./PriceAudit.vue?vue&type=template&id=06cfb958&scoped=true"
import script from "./PriceAudit.vue?vue&type=script&lang=js"
export * from "./PriceAudit.vue?vue&type=script&lang=js"
import style0 from "./PriceAudit.vue?vue&type=style&index=0&id=06cfb958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cfb958",
  null
  
)

export default component.exports